import React, { useState } from 'react';

const OrderComponent = () => {
  const [sdate, setSdate] = useState('');
  const [edate, setEdate] = useState('');
  const [filteredOrders, setFilteredOrders] = useState([]);

  const ordersData = [
    { srNo: 1, orderId: '980165ADA9135728909', productName: 'HAND SANITIZER 1Ltr.', productImage: '', mrp: 500, deliveryStatus: 'Pending', orderDate: '2024-11-15' },
    { srNo: 2, orderId: '8DAB435BAC399709387', productName: 'Easy Soft', productImage: '', mrp: 40, deliveryStatus: 'Pending', orderDate: '2024-11-10' },
    { srNo: 3, orderId: '6EECA807AC451072885', productName: 'NONI SOAP', productImage: '', mrp: 50, deliveryStatus: 'Shipped', orderDate: '2024-10-20' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    const filtered = ordersData.filter((order) => {
      const orderDate = new Date(order.orderDate);
      const startDate = new Date(sdate);
      const endDate = new Date(edate);
      return orderDate >= startDate && orderDate <= endDate;
    });
    setFilteredOrders(filtered);
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    margin: '0 auto',
    fontSize: '14px',
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
    width: '200px',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
    fontSize: '12px',
  };

  const inputStyle = {
    padding: '6px',
    fontSize: '12px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  };

  const buttonStyle = {
    padding: '6px 12px', // Smaller padding for a smaller button
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px', // Smaller font size
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    fontSize: '12px',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', fontSize: '18px' }}>Order Details</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Sdate</label>
            <input
              type="date"
              style={inputStyle}
              value={sdate}
              onChange={(e) => setSdate(e.target.value)}
            />
          </div>

          <div style={formGroupStyle}>
            <label style={labelStyle}>Edate</label>
            <input
              type="date"
              style={inputStyle}
              value={edate}
              onChange={(e) => setEdate(e.target.value)}
            />
          </div>

          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </div>
      </form>

      {/* Displaying the Order Data */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Order Id</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Product Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Product Image</th>
            <th style={{ ...thTdStyle, ...thStyle }}>MRP</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Delivery Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders.length > 0 ? (
            filteredOrders.map((order) => (
              <tr key={order.srNo}>
                <td style={thTdStyle}>{order.srNo}</td>
                <td style={thTdStyle}>{order.orderId}</td>
                <td style={thTdStyle}>{order.productName}</td>
                <td style={thTdStyle}>
                  {order.productImage ? <img src={order.productImage} alt="Product" style={{ width: '50px' }} /> : 'No Image'}
                </td>
                <td style={thTdStyle}>{order.mrp}</td>
                <td style={thTdStyle}>{order.deliveryStatus}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={thTdStyle}>No orders found for the selected date range</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OrderComponent;
